/**
 * Site-wide Click Spark (vanilla port of react-bits ClickSpark).
 */
(function () {
  var SPARK_COLOR = '#b85c42';
  var SPARK_SIZE = 14;
  var SPARK_RADIUS = 28;
  var SPARK_COUNT = 8;
  var DURATION = 420;

  function start() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (document.querySelector('.kk-click-spark')) return;

    var canvas = document.createElement('canvas');
    canvas.className = 'kk-click-spark';
    canvas.setAttribute('aria-hidden', 'true');
    document.body.appendChild(canvas);

    var ctx = canvas.getContext('2d');
    if (!ctx) return;

    var sparks = [];
    var running = false;

    function sizeCanvas() {
      var dpr = Math.min(window.devicePixelRatio || 1, 2);
      var width = window.innerWidth;
      var height = window.innerHeight;
      canvas.width = Math.floor(width * dpr);
      canvas.height = Math.floor(height * dpr);
      canvas.style.width = width + 'px';
      canvas.style.height = height + 'px';
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    }

    sizeCanvas();
    window.addEventListener('resize', sizeCanvas);

    function easeOut(t) {
      return t * (2 - t);
    }

    function draw(timestamp) {
      ctx.clearRect(0, 0, window.innerWidth, window.innerHeight);
      sparks = sparks.filter(function (spark) {
        var elapsed = timestamp - spark.startTime;
        if (elapsed >= DURATION) return false;

        var eased = easeOut(Math.min(1, elapsed / DURATION));
        var distance = eased * SPARK_RADIUS;
        var lineLength = SPARK_SIZE * (1 - eased);
        var x1 = spark.x + distance * Math.cos(spark.angle);
        var y1 = spark.y + distance * Math.sin(spark.angle);
        var x2 = spark.x + (distance + lineLength) * Math.cos(spark.angle);
        var y2 = spark.y + (distance + lineLength) * Math.sin(spark.angle);

        ctx.strokeStyle = SPARK_COLOR;
        ctx.lineWidth = 2.25;
        ctx.lineCap = 'round';
        ctx.beginPath();
        ctx.moveTo(x1, y1);
        ctx.lineTo(x2, y2);
        ctx.stroke();
        return true;
      });

      if (sparks.length) {
        requestAnimationFrame(draw);
      } else {
        running = false;
      }
    }

    function burst(x, y) {
      var now = performance.now();
      for (var i = 0; i < SPARK_COUNT; i += 1) {
        sparks.push({
          x: x,
          y: y,
          angle: (2 * Math.PI * i) / SPARK_COUNT,
          startTime: now,
        });
      }
      if (!running) {
        running = true;
        requestAnimationFrame(draw);
      }
    }

    document.addEventListener(
      'click',
      function (event) {
        burst(event.clientX, event.clientY);
      },
      true
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
